export enum IncomeStatementGroupType {
    OPERATIONAL = 'OPERATIONAL',
    REVENUE = 'REVENUE'
}
